import Vue from 'vue';

Vue.directive('wait-while', {
    bind(_, binding, vnode) {
        const instance = vnode.context.__$waitInstance;
        vnode.child.$on('start', () => instance.start(binding.value));
        vnode.child.$on('stop', () => instance.end(binding.value));
    }
});
